import src from "IMAGE";
export default { src, width: 18, height: 16, blurWidth: 0, blurHeight: 0};
